import config from '../jsons/config.json';

//vrací adresu BE na základě aktuální adresy, kde beží FE. Pro localhost se doplní DEV URL
export const getApiUrl = (protocol: string, path: string) => {
    const scriptUrl = (document as any).currentScript?.src;
    let origin = new URL(scriptUrl);
    origin.pathname = '/';

    if (origin.toString() === 'http://localhost:3000/') {
        origin = new URL(config.apiDevelopmentURL);
    }

    origin.protocol = protocol;
    origin.pathname = path;

    return origin.toString();
}

//vrátí URL podle aktuálního nastavení routeru
export const createUrl = (path: string) => `#${path}`;

export const objectValuesReplace = (obj: any, find: any, replace: any): any => {
    const out: any = {};

    Object.keys(obj).forEach(key => {
        let val = obj[key];

        if (val === find) val = replace;

        out[key] = val;
    });

    return out;
}
